/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { VersionDto } from '../models/version-dto';

@Injectable({ providedIn: 'root' })
export class VersionControllerService extends DataBaseService {

  /**
   * Path part for operation versionControllerGetVersion
   */
  static readonly VersionControllerGetVersionPath = '/v1/version';

  /**
   * Get versions
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVersion()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVersion$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<VersionDto>> {

    const rb = new RequestBuilder(this.rootUrl, VersionControllerService.VersionControllerGetVersionPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VersionDto>;
      })
    );
  }
  /**
   * Get versions
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getVersion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVersion(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<VersionDto> {

    return this.getVersion$Response(params).pipe(
      map((r: StrictHttpResponse<VersionDto>) => r.body as VersionDto)
    );
  }

}
